'use es6';

import { combineReducers } from 'redux';
import Immutable from 'immutable';
import * as RequestState from 'ecosystem-marketplace-core/constants/RequestState';
import CollectionListing from 'ecosystem-marketplace-core/records/CollectionListing';
import * as ActionTypes from '../actions/ActionTypes';

const requestState = (state = RequestState.UNINITIALIZED, action) => {
  switch (action.type) {
    case ActionTypes.COLLECTIONS_REQUESTED:
      return RequestState.PENDING;

    case ActionTypes.COLLECTIONS_RECEIVED:
      return RequestState.SUCCEEDED;

    case ActionTypes.COLLECTIONS_FAILED:
      return RequestState.FAILED;

    default:
      return state;
  }
};

const listings = (state = Immutable.List(), action) => {
  switch (action.type) {
    case ActionTypes.COLLECTIONS_RECEIVED:
      {
        return Immutable.List(action.payload.map(listing => CollectionListing.from(listing)));
      }

    default:
      return state;
  }
};

export default combineReducers({
  requestState,
  listings
});